export const IconTriangle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="10"
    viewBox="607.896 44 20 10"
    // color="currentColor"
  >
    <path
      d="m607.896 44 10 10 10-10h-20Z"
      fillRule="evenodd"
      data-name="↳Color"
      fill="currentColor"
    />
  </svg>
);
